import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { AnchorTop } from '@ztechapps/webui.util'

export type PrivateLayoutProps = {
  header: ReactNode
  sidebar?: ReactNode
}

export const PrivateLayout = ({ header, sidebar }: PrivateLayoutProps) => {
  return (
    <>
      {header}
      {sidebar}
      <main id="main">
        <section>
          <Outlet />
        </section>
      </main>

      <AnchorTop />
    </>
  )
}
